import React from 'react';
interface TherapistsSectionProps {
  onOpenWaitlist: () => void;
}
export const TherapistsSection: React.FC<TherapistsSectionProps> = ({
  onOpenWaitlist
}) => {
  return <section id="therapists" aria-labelledby="therapists-heading" className="section-y bg-white" data-id="element-191" data-mp="3mib9ryhnyzni">
      <div className="section-container" data-id="element-192" data-mp="3ig7oyj93uipk">
        <div className="flex flex-col gap-8 rounded-2xl bg-sandstone/50 p-8 md:p-12 lg:flex-row lg:items-center lg:justify-between lg:gap-16" data-id="element-193" data-mp="3ihj0x6cpewrr">
          <div className="max-w-2xl" data-id="element-194" data-mp="2psbs9ejjcqss">
            <p className="text-sm font-semibold uppercase tracking-[0.14em] text-deep-juniper" data-id="element-195" data-mp="2ptddgbu9mto8">
              For therapists
            </p>
            <h2 id="therapists-heading" className="section-heading mt-3" data-id="element-196" data-mp="33pgxjcbfdlmz">
              More room for the human work of therapy.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ink-text/80" data-id="element-197" data-mp="j0ktcbcsx9hp">
              Re:Joy is being built to support therapist-led group care, with
              tools for intake, matching, coordination, and understanding
              progress.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-198" data-mp="1c0ylspez64dh">
            <button type="button" onClick={onOpenWaitlist} className="btn-secondary" data-id="element-199" data-mp="1bzonq084gw6u">
              Register interest as a therapist
            </button>
          </div>
        </div>
      </div>
    </section>;
};